import { Grid } from '@elliemae/ds-grid';
import { useTheme } from '@elliemae/ds-system';

const rad = 54;
const cir = 2 * Math.PI * rad;
export const ProgressIndicator = ({ progress = 0 }) => {
  const factor = progress / 100;
  const theme = useTheme();
  const dashoffset = cir * (1 - factor);
  return (
    <Grid height={theme.space.s} width={theme.space.s} justifyContent="center" alignItems="center">
      <svg width="23" height="23" viewBox="0 0 120 120" transform="rotate(-90)">
        <circle cx="60" cy="60" r="54" fill="none" strokeWidth="12" stroke={`${theme.colors.neutral[100]}`} />
        <circle
          cx="60"
          cy="60"
          r="54"
          strokeWidth="12"
          fill="none"
          strokeDasharray={`${cir}px`}
          strokeDashoffset={`${dashoffset}px`}
          stroke={`${theme.colors.brand[600]}`}
          strokeLinecap="round"
        />
      </svg>
    </Grid>
  );
};
